import { type Theme } from "@mui/material";

import { type MuiThemeComponentOverride } from "./types";

function shouldShowVariant(children: React.PropsWithChildren["children"], oneOf: string[]): boolean {
  if (typeof children !== "string") {
    return false;
  }

  const firstInitial = children
    .toLowerCase()
    .trim()
    .split(" ")
    .map((el) => el.trim())
    .filter((el) => Boolean(el))[0]
    ?.split("")[0];

  if (!firstInitial) {
    return false;
  }

  return oneOf.includes(firstInitial);
}

export function getMuiAvatar(theme: Theme): MuiThemeComponentOverride<"MuiAvatar"> {
  return {
    MuiAvatar: {
      defaultProps: {
        //slots: { img: Fragment },
      },
      styleOverrides: {
        root: {
          "&:has(svg.MuiAvatar-fallback)": { display: "none" },
          variants: [
            {
              props({ children }) {
                return shouldShowVariant(children, ["a", "g", "m", "s"]);
              },
              style: { backgroundColor: theme.palette.brand.blue["500"].main },
            },
            {
              props({ children }) {
                return shouldShowVariant(children, ["b", "h", "n", "t", "y"]);
              },
              style: { backgroundColor: theme.palette.brand.green["500"].main },
            },
            {
              props({ children }) {
                return shouldShowVariant(children, ["c", "i", "o", "u"]);
              },
              style: { backgroundColor: theme.palette.brand.orange["500"].main },
            },
            {
              props({ children }) {
                return shouldShowVariant(children, ["d", "j", "p", "v"]);
              },
              style: { backgroundColor: theme.palette.brand.purple["500"].main },
            },
            {
              props({ children }) {
                return shouldShowVariant(children, ["e", "k", "q", "w", "z"]);
              },
              style: { backgroundColor: theme.palette.brand.red["500"].main },
            },
            {
              props({ children }) {
                return shouldShowVariant(children, ["f", "l", "r", "x"]);
              },
              style: { backgroundColor: theme.palette.brand.yellow["500"].main },
            },
          ],
        },
      },
    },
  };
}
